import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of as observableOf } from 'rxjs';
import { InputRadioOptionI } from '../../../../../shared/modules/configurable-form/components/form-inpu-radio/models/input-radio-option-i';
import { InputRadioOptionLoaderI } from '../../../../../shared/modules/configurable-form/components/form-inpu-radio/models/input-radio-option-loader-i';
import { selectCalendarResponse } from '@ordersnproducts/modules/multiple-order-online/redux/selectors/shipment-location-worksheets.selector';
import { Store } from '@ngrx/store';
import { State } from '@cemex/cmx-client-layout';
import { filter, map } from 'rxjs/operators';
import { SpecFieldNames } from '../../constants/specification-field-names.enum';
import { FormGroup } from '@angular/forms';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import OrdersFormsActions from '@ordersnproducts/modules/multiple-order-online/redux/actions/orders-forms.action';

@Injectable()
export class YesNoOptionLoader implements InputRadioOptionLoaderI {
  constructor(private translate: TranslateService) {}

  loadOptions(): Observable<InputRadioOptionI[]> {
    return observableOf([
      {
        id: true,
        name: this.translate.instant('views.common.yes'),
      },
      {
        id: false,
        name: this.translate.instant('views.common.no'),
      },
    ]);
  }
}

@Injectable()
export class WashOnSiteOptionLoader implements InputRadioOptionLoaderI {
  constructor(
    private translate: TranslateService,
    private store: Store<State>,
  ) {}
  /**
   * Loads the options for the wash on site field.
   * @param formGroup The form group to set the value on.
   * @returns An observable of InputRadioOptionI array.
   */
  loadOptions(formGroup: FormGroup): Observable<InputRadioOptionI[]> {
    return this.store.select(selectCalendarResponse).pipe(
      filter((state) => state !== undefined && state !== null),
      map((calendar) => {
        const hasWashOnSiteFromJobsite = calendar?.pump?.['washOnSite'] ?? false;
        formGroup.get(SpecFieldNames.CLEANING_ON_SITE).setValue(hasWashOnSiteFromJobsite);
        const id = formGroup.get(SpecFieldNames.ID).value;
        this.store.dispatch(
          OrdersFormsActions.updateForm({
            formId: id,
            formControlName: SpecFieldNames.CLEANING_ON_SITE,
            formControlvalue: hasWashOnSiteFromJobsite,
            formIsValid: formGroup.valid,
          }),
        );
        const yesNoOptions: InputRadioOptionI[] = [
          {
            id: true,
            name: this.translate.instant('views.common.yes'),
          },
          {
            id: false,
            name: this.translate.instant('views.common.no'),
          },
        ];
        return yesNoOptions;
      }),
    );
  }
}
